import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Ratings = lazy(() => import('../container/ratings'));
const ModulesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/ModulesRatingStatistics'),
);
const SectionsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/SectionsRatingStatistics'),
);
const LecturesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/LecturesRatingStatistics'),
);
const SingleLectureRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/SingleLectureRatingStatistics'),
);
const AllSectionsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/AllSectionsRatingStatistics'),
);
const AllLecturesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/lecturesRatings/AllLecturesRatingStatistics'),
);

const ModulesTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/ModulesRatingStatistics'),
);
const SectionsTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/SectionsRatingStatistics'),
);
const LecturesTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/LecturesRatingStatistics'),
);
const SingleLectureTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/SingleLectureRatingStatistics'),
);
const AllSectionsTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/AllSectionsRatingStatistics'),
);
const AllExercisesTeacherCommentsRatingStatistics = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/AllExercisesRatingStatistics'),
);
const TeacherCommentsAllRatings = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/TeacherCommentsAllRatings'),
);
const TeacherCommentsPeriodicRatings = lazy(() =>
  import('../container/ratings/overview/teacherCommentRatings/TeacherCommentsPeriodicRatings'),
);

const ModulesExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/ModulesRatingStatistics'),
);
const SectionsExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/SectionsRatingStatistics'),
);
const LecturesExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/LecturesRatingStatistics'),
);
const SingleLectureExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/SingleLectureRatingStatistics'),
);
const AllSectionsExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/AllSectionsRatingStatistics'),
);
const AllExercisesExercisesRatingStatistics = lazy(() =>
  import('../container/ratings/overview/exerciseRatings/AllExercisesRatingStatistics'),
);

const ExerciseVerificationsAllRatings = lazy(() =>
  import('../container/ratings/overview/exerciseVerificationRatings/ExerciseVerificationsAllRatings'),
);
const ExerciseVerificationsCounts = lazy(() =>
  import('../container/ratings/overview/exerciseVerificationRatings/ExerciseVerificationsCounts'),
);
const AllTicketAnswerRatings = lazy(() =>
  import('../container/ratings/overview/ticketAnswersRatings/AllTicketAnswerRatings'),
);
const MonthlyTicketRatingsStats = lazy(() =>
  import('../container/ratings/overview/ticketAnswersRatings/MonthlyTicketRatingsStats'),
);

const RatingsRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={Ratings} />
      <Route
        path={`${path}/lectures/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics/:subjectId`}
        component={SingleLectureRatingStatistics}
      />
      <Route
        path={`${path}/lectures/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics`}
        component={LecturesRatingStatistics}
      />
      <Route
        path={`${path}/lectures/modules-statistics/:moduleId/sections-statistics`}
        component={SectionsRatingStatistics}
      />
      <Route path={`${path}/lectures/lectures-statistics`} component={AllLecturesRatingStatistics} />
      <Route path={`${path}/lectures/sections-statistics`} component={AllSectionsRatingStatistics} />
      <Route path={`${path}/lectures/modules-statistics`} component={ModulesRatingStatistics} />
      <Route
        path={`${path}/teacher-comments/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics/:subjectId`}
        component={SingleLectureTeacherCommentsRatingStatistics}
      />
      <Route
        path={`${path}/teacher-comments/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics`}
        component={LecturesTeacherCommentsRatingStatistics}
      />
      <Route
        path={`${path}/teacher-comments/modules-statistics/:moduleId/sections-statistics`}
        component={SectionsTeacherCommentsRatingStatistics}
      />
      <Route path={`${path}/teacher-comments/modules-statistics`} component={ModulesTeacherCommentsRatingStatistics} />
      <Route
        path={`${path}/teacher-comments/sections-statistics`}
        component={AllSectionsTeacherCommentsRatingStatistics}
      />
      <Route
        path={`${path}/teacher-comments/exercises-statistics`}
        component={AllExercisesTeacherCommentsRatingStatistics}
      />
      <Route path={`${path}/teacher-comments/all-ratings`} component={TeacherCommentsAllRatings} />
      <Route path={`${path}/teacher-comments/periodic-ratings`} component={TeacherCommentsPeriodicRatings} />
      <Route
        path={`${path}/exercises/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics/:subjectId`}
        component={SingleLectureExercisesRatingStatistics}
      />
      <Route
        path={`${path}/exercises/modules-statistics/:moduleId/sections-statistics/:sectionId/lectures-statistics`}
        component={LecturesExercisesRatingStatistics}
      />
      <Route
        path={`${path}/exercises/modules-statistics/:moduleId/sections-statistics`}
        component={SectionsExercisesRatingStatistics}
      />
      <Route path={`${path}/exercises/modules-statistics`} component={ModulesExercisesRatingStatistics} />
      <Route path={`${path}/exercises/sections-statistics`} component={AllSectionsExercisesRatingStatistics} />
      <Route path={`${path}/exercises/exercises-statistics`} component={AllExercisesExercisesRatingStatistics} />

      <Route path={`${path}/exercises-verifications/counts`} component={ExerciseVerificationsCounts} />
      <Route path={`${path}/exercises-verifications/all-ratings`} component={ExerciseVerificationsAllRatings} />
      <Route path={`${path}/ticket-answers/all-ratings`} component={AllTicketAnswerRatings} />
      <Route path={`${path}/ticket-answers/monthly-ratings`} component={MonthlyTicketRatingsStats} />
    </Switch>
  );
};

export default RatingsRoutes;
